import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PasswordRecoveryModule } from 'src/app/shared/modules/auth/password-recovery/password-recovery.module';
import { RecoverPasswordComponent } from './recover-password.component';

@NgModule({
    imports: [CommonModule, PasswordRecoveryModule],
    declarations: [RecoverPasswordComponent],
})
export class RecoverPasswordAllianceModule {}
